<template>
    <div class="sticky bottom-0 border-t border-gray-200 bg-gray-50 dark:bg-gray-800 dark:border-gray-600 px-4 flex items-center justify-between sm:px-0" v-if="pageRange.length > 1">
        <div class="w-0 flex-1 flex">
            <button type="button" v-if="links.prev" aria-label="Previous" :tabindex="!links.prev && -1" @click.self.prevent="previousPage" class="-mt-px border-t-2 pl-6 border-transparent pt-6 pb-6 pr-1 inline-flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 transition">
                <icon name="arrow-left" class-icon="mr-3 h-5 w-5" fill="currentColor" />
                {{ $t('pagination.previous') }}
            </button>
        </div>
        <div class="hidden md:flex">
            <template v-for="(page, key) in pageRange" >
                <button type="button" @click.self.prevent="selectPage(page)" :key="key" :class="page === currentPage ? activeClass : 'border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-500 focus:text-gray-700 focus:border-gray-500 hover:bg-gray-200 dark:border-gray-600 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:hover:bg-gray-900'" class="-mt-px border-t-2 pt-6 pb-6 px-4 inline-flex items-center text-sm leading-5 font-medium focus:outline-none transition">
                    {{ page }}
                </button>
            </template>
        </div>
        <div class="w-0 flex-1 flex justify-end">
            <button type="button" v-if="links.next" aria-label="Next" :tabindex="!links.next && -1" @click.self.prevent="nextPage" class="-mt-px border-t-2 pr-6 border-transparent pt-6 pb-6 pl-1 inline-flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 transition">
                {{ $t('pagination.next') }}
                <icon name="arrow-right" class-icon="ml-3 h-5 w-5" fill="currentColor" />
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'table-pagination',

    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        links: {
            type: Object,
            default: () => {}
        },
        limit: {
            type: Number,
            default: 3
        },
        activeColor: {
            type: String,
            default: 'indigo'
        },
    },

    computed: {
        currentPage () {
            return this.meta.current_page;
        },
        activeClass() {
            switch (this.activeColor) {
                case 'indigo':
                    return 'border-indigo-500 bg-indigo-100 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700 hover:text-indigo-700 hover:border-indigo-700 hover:bg-indigo-200 dark:border-indigo-300 dark:bg-indigo-600 dark:text-indigo-300 dark:focus:text-indigo-200 dark:focus:border-indigo-200 dark:hover:text-indigo-200 dark:hover:border-indigo-200 dark:hover:bg-indigo-700'
            }
        },
        pageRange () {
            if (this.limit === -1) {
                return 0
            }
            if (this.limit === 0) {
                return this.meta.total_pages
            }
            var current = this.currentPage
            var last = this.meta.total_pages
            var delta = this.limit
            var left =  current - delta
            var right = current + delta + 1 + (left <= 0 ? delta - (delta + left) : 0)
            var range = []
            var pages = []
            var l

            for (var i = 1; i <= last; i++) {
                if (i === 1 || i === last || (i >= left && i < right)) {
                    range.push(i);
                }
            }

            range.forEach(function (i) {
                if (l) {
                    if (i - l === 2) {
                        pages.push(l + 1);
                    } else if (i - l !== 1) {
                        pages.push('...');
                    }
                }
                pages.push(i);
                l = i;
            });

            return pages;
        }
    },

    methods: {
        previousPage () {
            this.selectPage((this.currentPage - 1));
        },
        nextPage () {
            this.selectPage((this.currentPage + 1));
        },
        selectPage (page) {
            if (page === '...' || page === this.currentPage) {
                return;
            }

            this.$emit('paginate', parseInt(page));
        }
    }
}
</script>
